/// <amd-module name="VSS/Diagnostics/Dialog/PerfDataProviderExceptionsDialog" />
import { IServerException, IVssContributionService } from "VSS/Platform/Contribution";
import { ClientContribution as Contribution, ContributionQueryOptions } from "VSS/Platform/Contracts/Contributions";
import {
    Components,
    IVssComponentContext,
    IVssComponentProperties,
    VssComponent,
    IVssLayoutManager,
    WrappedComponent,
    IVssComponentDetail
} from "VSS/Platform/Layout";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import { SelectionMode } from "OfficeFabric/Selection";
import React = require("react");
import { Dialog } from "VSSUI/Dialog";
import {
    DetailsList,
    ColumnActionsMode,
    ConstrainMode,
    DetailsListLayoutMode,
    DetailsRow,
    IColumn,
    IDetailsRowProps,
    CheckboxVisibility
} from "OfficeFabric/DetailsList";

interface IPerfDataProviderExceptionsDialog {
    onDismiss: () => void;
}

interface IDataProviderExceptionDetail {
    id: string;
    exceptionType: string;
    message: string;
    stackTrace?: string;
}

class PerfDataProviderExceptionsDialog extends VssComponent<IPerfDataProviderExceptionsDialog> {
    public render(): JSX.Element {
        const contributionService = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
        const exceptions = contributionService.getDataProviderExceptions();

        const items: IDataProviderExceptionDetail[] = Object.keys(exceptions).map(contributionId => ({
            id: contributionId,
            ...exceptions[contributionId]
        }));

        return (
            <Dialog
                onDismiss={this.props.onDismiss}
                titleProps={{ text: "Data Provider Exceptions" }}
                showCloseButton={true}
                lightDismiss={false}
                className="dialog-content dialog--data-provider-exceptions"
                calloutClassName="performance-dialog dialog--data-provider-errors"
                calloutContentClassName="dialog-container dialog-full-size"
            >
                <DetailsList
                    constrainMode={ConstrainMode.unconstrained}
                    layoutMode={DetailsListLayoutMode.justified}
                    compact={true}
                    selectionMode={SelectionMode.none}
                    items={items}
                    columns={[
                        {
                            key: "details",
                            name: "Details",
                            fieldName: "",
                            minWidth: 150,
                            maxWidth: 350,
                            isResizable: true,
                            onRender: this.renderDetailsColumn
                        },
                        {
                            key: "stackTrace",
                            fieldName: "stackTrace",
                            name: "StackTrace",
                            className: "exception-stack-trace-column",
                            minWidth: 400,
                            isMultiline: true,
                            isResizable: true
                        }
                    ]}
                />
            </Dialog>
        );
    }

    private renderDetailsColumn = (item: IDataProviderExceptionDetail) => {
        return (
            <div>
                <div className="exception-contribution-id">{item.id}</div>
                <div>{item.exceptionType}</div>
                <div>{item.message}</div>
            </div>
        );
    };
}

Components.add("vss.perf-data-provider-exceptions-dialog", PerfDataProviderExceptionsDialog);
